<template>
  <div id="playerPreviewPopUp" refs="playerPreviewPopUp" :class="{'is-visible': isVisible}">
    <div :class="['content', {'vertical': previewOrientation === 'vertical', 'normal-view': !led}]">
      <div class="close-icon" @click="handleCloseIconClick($event)"></div>
      <div v-if="preview !== null" class="preview">
        <!-- Project Preview -->
        <template v-if="['svg', 'html'].indexOf(preview.type) >= 0">
          <iframe :id="`projectFramePreview`"
            :src="$utils.filterMediaPreviewUrl(preview.url, { queryParams: { dimensions: preview.dimensions}})"
            :class="['svg-preview', 'template-target-on-refresh-token', 'media-project-file', `media-preview-${preview._edit.uid}`]">
          </iframe>
        </template>

        <!-- For Not IE Browsers (IMAGE)-->
        <template v-if="preview.type === 'img' && !preview.videopreviews">
          <img v-if="$utils.getBrowser() !== 'IE'"
            :src="$utils.filterMediaPreviewUrl(preview.url, { queryParams: { dimensions: preview.dimensions}})"
            class="object-fit_cover_center"/>

          <!-- For IE Browsers (IMAGE)-->
          <div v-if="$utils.getBrowser() === 'IE'"
            class="object-fit_fix_on_ie"
            :style="{'backgroundImage': `url(${$utils.filterMediaPreviewUrl(preview.url, { queryParams: { dimensions: preview.dimensions}})})`}">
          </div>
        </template>

        <video v-if="preview.videopreviews" id="playerPreviewPopUpVideoPreview" ref="playerPreviewPopUpVideoPreview" controls>
          <source v-for="(videopreview, key) in preview.videopreviews"
            :key="key"
            :src="$utils.filterMediaPreviewUrl(videopreview.url, { queryParams: { dimensions: preview.dimensions}})"
            :type="videopreview.format"
          />
        </video>
      </div>
    </div>
  </div>
</template>

<script src="./player-preview-popup.js"></script>
<style lang="scss" src="./player-preview-popup.scss"></style>
